// src/components/TypedText.js
import React, { useEffect, useRef } from 'react';
import Typed from 'typed.js';

const TypedText = () => {
  const el = useRef(null);

  useEffect(() => {
    const typed = new Typed(el.current, {
      strings: [
        "Passionate about MERN Stack Development",
        "Passionate About AI/ML",
        "Passionate About Full Stack Development",
      ],
      typeSpeed: 50,
      backSpeed: 25,
      loop: true,
      backDelay: 2000,
      smartBackspace: true,
      showCursor: true
    });

    return () => {
      typed.destroy();
    };
  }, []);

  return <span ref={el}></span>;
};

export default TypedText;
